export const ExportPaperRepository = Symbol('ExportPaperRepository');
